"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserLevel;
(function (UserLevel) {
    UserLevel[UserLevel["Employee"] = 0] = "Employee";
    UserLevel[UserLevel["Manager"] = 3] = "Manager";
    UserLevel[UserLevel["Partner"] = 4] = "Partner";
    UserLevel[UserLevel["Owner"] = 5] = "Owner";
    UserLevel[UserLevel["Admin"] = 7] = "Admin";
})(UserLevel = exports.UserLevel || (exports.UserLevel = {}));
exports.UserLevels = Object.values(UserLevel).filter(function (l) { return typeof l === "number"; });
//# sourceMappingURL=user.js.map